import React from 'react';
import { Box } from '@mui/material';

const NOTE_COLORS = {
  200: { fill: '#E8D4A8', stroke: '#8B7355', text: '#3D2914' },
  100: { fill: '#A8D4A8', stroke: '#4A7A4A', text: '#1A3D1A' },
  50: { fill: '#F0C080', stroke: '#B87333', text: '#5C3A1E' },
  20: { fill: '#A8C8E8', stroke: '#3A6A9A', text: '#1A3050' },
  10: { fill: '#E8A8A8', stroke: '#9A3A3A', text: '#501A1A' },
  5: { fill: '#D0D0D0', stroke: '#606060', text: '#303030' }
};

const COIN_COLORS = {
  2: { fill: '#E8E0C0', stroke: '#A89860', text: '#504820' },
  1: { fill: '#E8E8E8', stroke: '#909090', text: '#404040' },
  0.5: { fill: '#E8D8C8', stroke: '#A08060', text: '#503820' },
  0.2: { fill: '#E8D0D0', stroke: '#A06060', text: '#502020' },
  0.1: { fill: '#E8E0E8', stroke: '#908098', text: '#403048' }
};

function formatLabel(value) {
  if (value >= 1) return `${value} \u20AC`;
  // Centesimi: sempre due cifre decimali (0.50, 0.20, 0.10)
  return `${value.toFixed(2)} \u20AC`;
}

export function EuroNoteArt({ value, width = 140, height = 56 }) {
  const c = NOTE_COLORS[value] || NOTE_COLORS[20];
  return (
    <Box
      component="svg"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 160 80"
      role="img"
      aria-label={`${value} euro`}
      sx={{ width, height, display: 'block', flexShrink: 0 }}
    >
      <rect width="160" height="80" rx="4" fill={c.fill} stroke={c.stroke} strokeWidth="2" />
      <text
        x="80"
        y="48"
        textAnchor="middle"
        fontFamily="Arial, sans-serif"
        fontSize="28"
        fontWeight="bold"
        fill={c.text}
      >
        {formatLabel(value)}
      </text>
    </Box>
  );
}

export function EuroCoinArt({ value, size = 72 }) {
  const c = COIN_COLORS[value] || COIN_COLORS[1];
  const fontSize = value >= 1 ? 22 : 14;
  return (
    <Box
      component="svg"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 80 80"
      role="img"
      aria-label={`${value} euro`}
      sx={{ width: size, height: size, display: 'block', flexShrink: 0 }}
    >
      <circle cx="40" cy="40" r="36" fill={c.fill} stroke={c.stroke} strokeWidth="3" />
      <text
        x="40"
        y={value >= 1 ? 48 : 46}
        textAnchor="middle"
        fontFamily="Arial, sans-serif"
        fontSize={fontSize}
        fontWeight="bold"
        fill={c.text}
      >
        {formatLabel(value)}
      </text>
    </Box>
  );
}

export function BanknoteButtonArt({ size = 36 }) {
  return (
    <Box
      component="svg"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      role="img"
      aria-hidden
      sx={{ width: size, height: size, display: 'block' }}
    >
      <rect x="4" y="12" width="40" height="24" rx="2" fill="#A8C8E8" stroke="#3A6A9A" strokeWidth="1.5" />
      <text x="24" y="28" textAnchor="middle" fontFamily="Arial, sans-serif" fontSize="14" fontWeight="bold" fill="#1A3050">
        {'\u20AC'}
      </text>
    </Box>
  );
}

export function EuroDenominationArt({ value, kind }) {
  if (kind === 'coin') {
    return <EuroCoinArt value={value} />;
  }
  return <EuroNoteArt value={value} />;
}
